module.exports = __webpack_public_path__ + "static/media/gb.ead1aa6a.webp";